export default __webpack_public_path__ + "static/media/Editorial.7735cea0.svg";